import React, { useMemo } from 'react';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import { LightGreySubtitleColor } from '@core/theme/baseTheme';
import { useLanguage } from 'FielderUtils/Contexts/LanguageContext';
import { buildTaskDetailIcons } from '~/FielderElements/SmartTaskTable/SmartTaskIconsUtils';

const TaskDetailIconsContainer = styled(Grid)`
    color: ${LightGreySubtitleColor};
`;
const SmartTaskDetailIcons = ({ icons, taskIcons }) => {
	const lan = useLanguage();
	const taskDetailIcons = useMemo(
		() => (taskIcons ? taskIcons : buildTaskDetailIcons(icons, lan)),
		[taskIcons, icons, lan]
	);
	return (
		<TaskDetailIconsContainer container spacing={1}>
			{taskDetailIcons.map(({ text, icon }, index) => (
				<Grid key={`task-detail-icon-${text}-${index}`} size={{ lg:3 }}>
					<Tooltip title={text}>{icon}</Tooltip>
				</Grid>
			))}
			{/*taskDetailIcons.map(({ text, icon }) => (
				<Grid size={{ lg:3 }}>
					<Tooltip key={"tooltip-" + text} title={text}>{icon}</Tooltip>
				</Grid>
			))*/}
		</TaskDetailIconsContainer>
	);
};
export default React.memo(SmartTaskDetailIcons);
